import { ExActionTree } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import * as api from "@/api";

const actions: ExActionTree<State, Actions, Getters, Mutations> = {
  async getPlans(ctx, params) {
    try {
      const response = await api.getPlans(params);
      // NOTE: 左メニューのカレンダーに表示するプラン一覧。プランがない場合は空配列を返す
      // 空配列を返してもデフォルトの「全部を表示」は表示されるので問題ない
      ctx.commit("getPlansSuccess", {
        plans: response?.data || []
      });
    } catch (error) {
      throw error;
    }
  },
  async createPlan(ctx, params) {
    try {
      const response = await api.createPlan(params);
      ctx.commit("createPlanSuccess", {
        plans: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async duplicatePlan(ctx, params) {
    try {
      const response = await api.duplicatePlan(params);
      ctx.commit("createPlanSuccess", {
        plans: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async updatePlan(ctx, params) {
    try {
      const response = await api.updatePlan(params);
      ctx.commit("updatePlanSuccess", {
        plans: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async deletePlan(ctx, params) {
    try {
      await api.deletePlan(params);
      ctx.commit("deletePlanSuccess", {
        planId: params.planId
      });
    } catch (error) {
      throw error;
    }
  }
};

export default actions;
